import React from "react";
import { Redirect } from "react-router-dom";

import dashboardRoutes from "./views/dashboard/DashboardRoutes";
import berandaRoute from "./views/Halaman/Beranda/BerandaRoutes";
import HalamanRoutes from "./views/Halaman/HalamanRoute";
import sejarahPerusahaanRoute from "./views/Halaman/SejarahPerusahaan/SejarahPerusahaanRoutes";
import infoUmumRoutes from "./views/InformasiUmum/infoUmumRoute";
import kotaRoutes from "./views/Kota/KotaRoute";
import adminRoute from "./views/Manajemen/Admin/AdminRoutes";
import anakPerusahaanRoute from "./views/Manajemen/AnakPerusahaan/AnakPerusahaanRoutes";
import asetInvestasiRoutes from "./views/Manajemen/AsetInvestasi/AsetInvestasiRoutes";
import csrRoutes from "./views/Manajemen/CSR/CSRRoutes";
import eMagazineRoute from "./views/Manajemen/E-Magazine/EMagazineRoutes";
import heroSectionRoute from "./views/Manajemen/HeroSection/HeroSectionRoutes";
import hotelRoutes from "./views/Manajemen/Hotel/HotelRoutes";
import inquiryRoute from "./views/Manajemen/Inquiry/InquiryRoutes";
import karirRoutes from "./views/Manajemen/Karir/KarirRoutes";
import KomiteGCGRoutes from "./views/Manajemen/KomiteGCG/KomiteGCGRoutes";
import laporanKeuanganRoute from "./views/Manajemen/LaporanKeuangan/LaporanKeuanganRoutes";
import laporanTahunanRoute from "./views/Manajemen/LaporanTahunan/LaporanTahunanRoutes";
import ManajemenPerusahaanRoutes from "./views/Manajemen/ManajemenPerusahaan/ManajemenPerusahaanRoutes";
import mediaRoutes from "./views/Manajemen/Media/MediaRoutes";
import mitraRoute from "./views/Manajemen/Mitra/MitraRoutes";
import portfolioRoutes from "./views/Manajemen/Portfolio/PortfolioRoutes";
import promosiRoute from "./views/Manajemen/Promosi/PromosiRoutes";
import propertyDevRoutes from "./views/Manajemen/PropertyDev/PropertyDevRoutes";
import setifikatRoute from "./views/Manajemen/Sertifikat/SertifikatRoutes";
import sheRoutes from "./views/Manajemen/SHE/SHERoutes";
import profileRoutes from "./views/Profile/ProfileRoutes";
import provinsiRoutes from "./views/Provinsi/ProvinsiRoute";

const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/home" />,
  },
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />,
  },
];

const routes = [
  ...dashboardRoutes,
  ...ManajemenPerusahaanRoutes,
  ...setifikatRoute,
  ...anakPerusahaanRoute,
  ...propertyDevRoutes,
  ...asetInvestasiRoutes,
  ...hotelRoutes,
  ...portfolioRoutes,
  ...mitraRoute,
  ...laporanTahunanRoute,
  ...laporanKeuanganRoute,
  ...KomiteGCGRoutes,
  ...mediaRoutes,
  ...eMagazineRoute,
  ...promosiRoute,
  ...csrRoutes,
  ...sheRoutes,
  ...karirRoutes,
  ...heroSectionRoute,
  ...adminRoute,
  ...berandaRoute,
  ...sejarahPerusahaanRoute,
  ...provinsiRoutes,
  ...kotaRoutes,
  ...infoUmumRoutes,
  ...HalamanRoutes,
  ...profileRoutes,
  ...inquiryRoute,
  ...redirectRoute,
  ...errorRoute,
];

export default routes;
